// src/utils.ts
function isDarkMode(setting, isSystemDark) {
  return setting === "dark" || !!isSystemDark && setting !== "light";
}
function disableAnimation(disableTransitionExclude = []) {
  const css = document.createElement("style");
  css.append(
    document.createTextNode(
      `
*${disableTransitionExclude.map((s) => `:not(${s})`).join("")} {
  -webkit-transition: none !important;
  -moz-transition: none !important;
  -o-transition: none !important;
  -ms-transition: none !important;
  transition: none !important;
}
      `
    )
  );
  document.head.append(css);
  return () => {
    ;
    (() => window.getComputedStyle(document.body))();
    setTimeout(() => {
      css.remove();
    }, 1);
  };
}
function mergeDefaultOptions(options) {
  return {
    storageKey: "use-dark",
    disableTransition: false,
    disableTransitionExclude: [],
    mode: "class",
    applyDarkMode: options?.mode === "data-theme" ? (isDark) => {
      document.documentElement.dataset.theme = isDark ? "dark" : "light";
    } : (isDark) => {
      document.documentElement.classList.toggle("dark", isDark);
      document.documentElement.classList.toggle("light", !isDark);
    },
    ...options
  };
}
var query = "(prefers-color-scheme: dark)";
function getSystemDarkSnapshot() {
  return window.matchMedia(query).matches;
}
function subscribeSystemDark(callback) {
  const matcher = window.matchMedia(query);
  matcher.addEventListener("change", callback);
  return () => {
    matcher.removeEventListener("change", callback);
  };
}

export {
  isDarkMode,
  disableAnimation,
  mergeDefaultOptions,
  getSystemDarkSnapshot,
  subscribeSystemDark
};
